import {DashboardDtoPaged} from '../../../../../global/api';
import {ServiceRequestStatusesByDate} from '../constants/service-requests-statuses-by-date';
import {ServiceRequestDashboardChildRow, ServiceRequestDashboardRow} from '../types/service-requests-dashboard.type';
import {getServiceRequestStatusByDate} from './getServiceRequestStatusByDate';

export const CONTRACT_STATUS_PRIORITY: ServiceRequestStatusesByDate[] = [
  ServiceRequestStatusesByDate.DEADLINE_OVERDUE,
  ServiceRequestStatusesByDate.DEADLINE_SOON,
  ServiceRequestStatusesByDate.IN_PROGRESS,
  ServiceRequestStatusesByDate.COMPLETED_NOT_CLOSED,
  ServiceRequestStatusesByDate.COMPLETED_ON_TIME,
];

export const getContractStatusByRequests = (
  requests: Array<Pick<ServiceRequestDashboardChildRow, 'statusByDate'>> | DashboardDtoPaged['serviceRequests'],
): ServiceRequestStatusesByDate | undefined => {
  const statusSet = new Set(
    (requests || [])
      .map((requestItem) => ('statusByDate' in requestItem ? requestItem.statusByDate : getServiceRequestStatusByDate(requestItem as never)))
      .filter((status): status is ServiceRequestStatusesByDate => Boolean(status)),
  );

  return CONTRACT_STATUS_PRIORITY.find((status) => statusSet.has(status));
};

export function buildServiceRequestsDashboardRows(data: DashboardDtoPaged[]): ServiceRequestDashboardRow[] {
  return data.map((contract, i) => {
    const requests = contract.serviceRequests || [];
    const hasArchivedRequests = requests.some((requestItem) => Boolean(requestItem.archived));
    const requestIdOccurrences = new Map<string, number>();

    let contractRowId = String(contract.contractNumber ?? '-') + i;

    const requestRows: ServiceRequestDashboardChildRow[] = requests.map((requestItem) => {
      const requestItemId = requestItem.id ? `${requestItem.id}` : 'missing';
      const occurrence = (requestIdOccurrences.get(requestItemId) || 0) + 1;
      requestIdOccurrences.set(requestItemId, occurrence);
      const requestRowId = `${contractRowId}:${requestItemId}:child:${occurrence}`;

      return {
        id: requestRowId,
        requestId: requestItem.id ? `${requestItem.id}` : undefined,
        fullAddress: requestItem.fullAddress,
        // временно игнорирование пока некорректная типизация в свагере
        // @ts-ignore
        customer: requestItem.customer,
        workers: requestItem.workers,
        // @ts-ignore
        plannedDate: requestItem.plannedDate,
        workLocation: requestItem.workLocation,
        statusCode: requestItem.statusCode,
        statusByDate: getServiceRequestStatusByDate(requestItem),
        archived: requestItem.archived,
      };
    });

    return {
      id: contractRowId,
      companyName: contract.companyName,
      startDate: contract.contractStartDate,
      contractNumber: contract.contractNumber,
      serviceType: contract.serviceType,
      statusByDate: getContractStatusByRequests(requests),
      archived: hasArchivedRequests,
      canToggle: requests.length > 0,
      contractRowId,
      serviceRequests: requestRows,
    };
  });
}
